import * as React from "react";
import Select from "react-select";
import usePromise from "../hooks/usePromise";
import { getManagedOrgs } from "../../libs/user";
import { useContext, useMemo } from "react";
import { RailsUserContext } from "../../libs/user_context";

interface IProps {
  userContext?: IUserContextNormalized;
  selectedOrgId: string;
  setSelectedOrgId: (orgId: string) => void;
}

function OrgPicker({
  userContext = null,
  selectedOrgId,
  setSelectedOrgId,
}: IProps) {
  const railsUserContext = useContext(RailsUserContext);

  let currentUser, currentOrg;
  if (userContext) {
    currentUser = userContext.user;
    currentOrg = userContext.org;
  } else {
    currentUser = railsUserContext.user;
    currentOrg = railsUserContext.org;
  }

  if (!currentUser || !currentOrg) {
    throw new Error(
      "OrgPicker unable to get user context from props or RailsUserContext"
    );
  }

  const [orgs, { loading }] = usePromise(() =>
    getManagedOrgs(currentUser.id).then(orgs => {
      // make sure the current user's org is in the list
      if (orgs && !orgs.find(org => org.id === currentOrg.id)) {
        return [...orgs, currentOrg];
      } else {
        return orgs;
      }
    })
  );

  const options = useMemo(
    () => (orgs || []).map(org => ({ label: org.name, value: org.id })),
    [orgs]
  );

  const value = useMemo(
    () => options.find(opt => opt.value === selectedOrgId),
    [selectedOrgId, options]
  );

  return (
    <>
      <Select
        isLoading={loading}
        options={options}
        value={value}
        clearable={false}
        onChange={(opt: ISelectOption) => {
          if(opt != null){
            setSelectedOrgId(opt.value);
          }
        }}
      />
    </>
  );
}

export default OrgPicker;



// WEBPACK FOOTER //
// ./app/javascript/components/core/OrgPicker.tsx